import * as tslib_1 from "tslib";
import * as React from 'react';
import { Check } from 'office-ui-fabric-react/lib/components/Check';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import onMailListItemClickHandler from '../utils/onMailListItemClickHandler';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import shouldTableShowCirclePersonas from 'owa-mail-list-actions/lib/utils/tables/shouldTableShowCirclePersonas';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import getIsChecked from '../selectors/getIsChecked';
var styles = require('./MailListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var PersonaCheckbox = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaCheckbox, _super);
    function PersonaCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (evt) {
            evt.stopPropagation();
            onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemCheckbox, _this.props.rowKey, _this.props.tableViewId);
        };
        // There's a double click on the outer component so must prevent propagation here (this is a corner case but causes an id of null error)
        _this.onDoubleClick = function (evt) {
            evt.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(PersonaCheckbox.prototype, "isChecked", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.tableViewId);
            return getIsChecked(tableView, this.props.rowKey, this.props.lastDeliveryTimestamp);
        },
        enumerable: true,
        configurable: true
    });
    PersonaCheckbox.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, lastSender = _a.lastSender, isUnauthenticatedSender = _a.isUnauthenticatedSender;
        var isSingleLine = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !==
            ReadingPanePosition.Right;
        var tableView = listViewStore.tableViews.get(this.props.tableViewId);
        var personaCheckboxContainerClasses = classNames(styles.personaCheckboxContainer, !isSingleLine && 'personaMarginThreeColumn');
        var personaCheckboxClasses = classNames(styles.personaCheckbox, (isSelected || tableView.isInCheckedMode) && styles.showCheckbox // Otherwise show persona
        );
        var checkboxClasses = classNames(styles.checkbox, this.isChecked && styles.checkboxChecked);
        // lastSender is undefined in rowModified notification payload, if the message is directly POSTed
        var lastSenderMailbox = lastSender ? lastSender.Mailbox : null;
        var showCirclePersonas = shouldTableShowCirclePersonas(tableView.tableQuery);
        return (React.createElement("div", { className: personaCheckboxContainerClasses },
            React.createElement("div", { className: personaCheckboxClasses },
                React.createElement("div", { className: styles.persona }, showCirclePersonas &&
                    lastSenderMailbox !== null && (React.createElement(PersonaControl, { name: lastSenderMailbox.Name, emailAddress: lastSenderMailbox.EmailAddress, size: PersonaSize.size28, showUnknownPersonaCoin: isUnauthenticatedSender }))),
                React.createElement("div", { className: checkboxClasses, onClick: this.onClick, onDoubleClick: this.onDoubleClick },
                    React.createElement(Check, { checked: this.isChecked })))));
    };
    tslib_1.__decorate([
        computed
    ], PersonaCheckbox.prototype, "isChecked", null);
    PersonaCheckbox = tslib_1.__decorate([
        observer
    ], PersonaCheckbox);
    return PersonaCheckbox;
}(React.Component));
export default PersonaCheckbox;
//# sourceMappingURL=PersonaCheckbox.js.map